import cx from 'classnames'

import { TableCell } from '../cell'
import { styles } from './table-row.styles'
import type { TableRowProps } from './table-row.types'

export function TableRow({
  heading,
  cells,
  className,
  ...rowProps
}: TableRowProps) {
  return (
    <tr className={cx(styles.base, className)} {...rowProps}>
      {cells.map(({ as: cellAs = 'td', ...cellProps }, cellIndex) => (
        <TableCell
          key={`cell-${cellIndex}`}
          as={heading ? 'th' : cellAs}
          {...cellProps}
        />
      ))}
    </tr>
  )
}
